<ion-select aria-label="Contatti"
            style="display: none"
            #actions
            (ionChange)="onSelectChange($event)"
            interface="action-sheet"
            placeholder="Contatti">
  <ion-select-option value="phone">{{ pharmacy()?.phoneNumber }}</ion-select-option>
  <ion-select-option value="navigate">{{ pharmacy()?.address }}</ion-select-option>
</ion-select>
